import React from 'react';
import styles from '@/pages/about/styles.less';
import UserIntro from '@/common/containers/UserIntro/index';

const About = () => {
  return (
    <div className={styles.container}>
      <UserIntro />
    </div>
  );
};

export default About;
